import styled from '@emotion/styled'
import { fontFamilies } from '@configs/styles/config'

export const SectionsRouteContainer = styled.div`
  display: flex;
  overflow: auto;
  height: 26px;
  align-items: center;
  margin-bottom: 32px;
`

export const RouteButton = styled.button<{ $active?: boolean }>`
  color: #999;
  padding: 0;
  margin-right: 12px;
  font-family: ${(props) =>
    props.$active ? fontFamilies.semiBold : fontFamilies.light};
  font-size: 12px;
  text-align: center;
  background: none;
  transition: 0.2s;
  color: #1a1e3d;
  white-space: nowrap;
  :hover {
    cursor: pointer;
  }
`

export const Separator = styled.div`
  margin-right: 12px;
  font-size: 1rem;
  color: #999;
`

export const LastUpdateCard = styled.div`
  display: flex;
  width: 168px;
  height: 34px;
  border-radius: 10px;
  margin-bottom: 32px;
  background: #eeefff;
  color: #7181ff;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontFamilies.semiBold};
  justify-content: center;
  align-items: center;
`

export const MDContainer = styled.div`
  max-width: 667px;
  @media (max-width: 600px) {
    padding: 16px;
  }
`

export const TabBarContainer = styled.div`
  display: flex;
  margin-top: 64px;
  width: 100%;
  border-bottom: 1px solid #d8d8d8;
`

export const TabContainer = styled.div<{ $active?: boolean }>`
  padding-bottom: 8px;
  margin-right: 10px;
  border-bottom: ${(props) =>
    props.$active ? '2px solid #7181FF' : '2px solid transparent'};
  color: ${(props) => (props.$active ? '#000000' : '#5B5B5B')};
  transition: border 0.2s ease-in-out;
`

export const TabElement = styled.div`
  padding: 4px 16px;
  font-family: ${fontFamilies.semiBold};
  font-size: 14px;
  transition: 0.5s;
  cursor: default;
  :hover {
    border-radius: 10px;
    background-color: #edefff;
  }
`

export const TopicsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 115px;
  row-gap: 128px;
  @media (max-width: 650px) {
    padding: 16px;
  }
`

export const TopicContainer = styled.div`
  width: 308px;
`

export const TopicHeader = styled.h1`
  font-family: ${fontFamilies.semiBold};
  font-size: 22px;
  margin-bottom: 32px;
  font-weight: 500;
`

export const TopicElement = styled.p`
  font-family: ${fontFamilies.semiBold};
  font-size: 16px;
  margin-bottom: 16px;
  text-decoration: underline;
  :hover {
    cursor: pointer;
  }
`

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`

export const PageContent = styled.div`
  max-width: 1064px;
`

export const ArticleContent = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PageTitle = styled.h1`
  font-family: ${fontFamilies.semiBold};
  font-size: 32;
  font-weight: 500;
`

export const PageSubTitle = styled.p`
  font-family: ${fontFamilies.regular};
  font-size: 18;
  font-weight: 400;
`
